/**
 * Removes every whitespace character from a value
 * @param {any} value
 * @returns {string}
 */
function withoutSpaces (value) {
    return String(value).replace(/\s/g, '');
}

module.exports = withoutSpaces;
